import { TranscriptionExtended } from 'flow/types/CallRecord';
import { View } from './types';

interface Props {
    transcription: TranscriptionExtended;
    view: View;
}

const getDisplayText = (transcription: TranscriptionExtended, view: View) => {
    if (view === 'summary') {
        return transcription.summary;
    }
    if (view === 'actions') {
        return (
            transcription.actions
                ?.map((a) => `${a.owner}: ${a.task}`)
                .join('\n') ?? ''
        );
    }
    return transcription.rawTranscript;
};

const TranscriptionTextView = ({ transcription, view }: Props) => (
    <div className="whitespace-pre-line">
        {getDisplayText(transcription, view)}
    </div>
);

export { getDisplayText };
export default TranscriptionTextView;
